import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ValidatorForm } from "react-form-validator-core";
import Header from "../../layout/Header";
import TextValidator from "../../partial/TextValidator";
import { updateCustomer, getSchemaList } from "../../../../actions/auth";
import { decrypt } from "../../../../utils/encodingdecoding";
import { backIcon2 } from "../../../../Image/Index";
import { customerRegistration } from "../../../../components/pages/campaigns/services";
import SelectValidator from "../../partial/SelectValidator";
import { getDropdownObject } from "../../../../utils/helper";
import { getUserTypeOptions, stateOption } from "../../../../utils";

const CreateUser = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const formData = location.state?.formData
  const formType = location?.state?.formType
  const type = location.state?.type;
  const customerType = location.state?.customerType;
  const userData = location.state?.userData;
  const [state, setState] = useState({});
  const [fieldConfigs, setFieldConfigs] = useState({});

  ValidatorForm.addValidationRule("is10Digits", (value) => {
    if (!value) return true;
    return /^[0-9]{10}$/.test(value);
  });

  ValidatorForm.addValidationRule("isValidEmail", (value) => {
    if (!value) return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  });

  const normalizedType = type?.toLowerCase();
  const fields = fieldConfigs[normalizedType] || [];

  const convertSchemaToField = (key, item) => {
    let isRequired = item?.isRequired;

    const requiredFields = ["name", "mobile"];

    if (requiredFields.includes(key.toLowerCase())) {
      isRequired = true;
    }
    return {
      name: key,
      label: item?.fielddisplayname,
      required: isRequired,
      placeholder: `Enter ${item?.fielddisplayname}`,
      type: item?.type === "string" ? "text" : item?.type,
      validators: isRequired ? ["required"] : [],
      errorMessages: isRequired ? [`Please enter ${item.fielddisplayname}`] : [],
      option: key === "state" ? stateOption : item?.enum
        ? [{ label: "Select", value: "" }, ...item.enum.map(ele => ({
          label: ele?.trim(),
          value: ele?.trim(),
        }))]
        : [{ label: "Select", value: "" }]
    };
  };

  useEffect(() => {
    const fetchSchemaList = async () => {
      setLoader(true);
      const token = JSON.parse(localStorage.getItem("token_gen"));
      const res = await getSchemaList(token?.access_token);

      const entries = Object.entries(res?.schema?.properties || {});

      let distributorRawFields
      if (formType === "edit") {
        const temp = getUserTypeOptions(decrypt(localStorage.getItem("Id"))).filter((item) => item.value === customerType)
        distributorRawFields = entries.filter(([key, item]) =>
          (item?.customerType || "").toUpperCase().includes(
            (temp?.[0]?.customerType || "").toUpperCase()
          )
          &&
          item?.isFormView)
      } else {
        distributorRawFields = entries.filter(([key, item]) =>
          (item?.customerType || "").toUpperCase().includes(
            (customerType || "").toUpperCase()
          )
          &&
          item?.isFormView)
      }

      const distributorConvertedFields = distributorRawFields.map(([key, item]) =>
        convertSchemaToField(key, item)
      );

      if (formType === "edit") {
        distributorConvertedFields.push({
          name: "cpcustomerstatus",
          label: "Customer Status",
          required: true,
          type: "dropdown",
          placeholder: "Select Status"
        });
      }

      setFieldConfigs((prev) => ({
        ...prev,
        [type?.toLowerCase()]: distributorConvertedFields,
      }));

      setLoader(false);
    };

    fetchSchemaList();
  }, []);

  useEffect(() => {
    if (formType === "edit" && fieldConfigs[normalizedType]) {
      const fields = fieldConfigs[normalizedType];
      let initialState = {};

      fields.forEach((field) => {
        const fieldName = field.name;

        initialState[fieldName] =
          userData?.[fieldName] ??
          formData?.[fieldName] ??
          "";
      });

      if (userData?.cpcustomerstatus) {
        initialState["cpcustomerstatus"] = userData.cpcustomerstatus;
      }
      setState(initialState);
    }
  }, [fieldConfigs, formType, normalizedType]);

  const option = [
    { label: "Pending", value: "Pending" },
    { label: "Approved", value: "Approved" },
    { label: "Reject", value: "Reject" },
  ];

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoader(true)
      const token = JSON.parse(localStorage.getItem("token_gen"));
      const allowedFields = (fieldConfigs[type?.toLowerCase()] || []).map((f) => f.name);

      let filteredPayload = allowedFields.reduce((acc, field) => {
        acc[field] = state[field] ?? "";
        return acc;
      }, {});

      if (formType == "create") {
        filteredPayload = {
          ...filteredPayload,
          cpcustomertype: type,
          customerType: type,
          cpcustomerstatus: "Pending",
          cpkycstatus: "Pending",
        };
        const customerReg = await customerRegistration(token.access_token, JSON.stringify(filteredPayload));
        if (customerReg.message === "Request processed successfully.") {
          swal("Success", `User create successfully`, "success");
          navigate(-1);
        } else {
          swal("Error", customerReg.message, "error");
        }
      } else {
        const res = await updateCustomer(token.access_token, formData?.customer_Code, filteredPayload)
        if (res.message === "Request processed successfully.") {
          swal("Success", `Personal details update successfully`, "success");
          navigate(-1);
        } else {
          swal("Error", res.message, "error");
        }
      }
      setLoader(false)

    } catch (err) {
      setLoader(false)
    }

  };

  const onChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleChangeState = (name, e) => {
    setState({ ...state, [name]: e });
  }


  return (
    <>
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <Header name={"User Management"} />
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="dashboard__profileSettingsMain">
            <div className="dashboard__heading">
              <div className="dashboard__headingLeft">
                <div className="dashboard__headingBackLink">
                  <Link to="" onClick={() => navigate(-1)}>
                    <img src={backIcon2} alt="" />
                    <div className="dashboard__headingContent">
                      <h3>{location?.state?.formType === "create" ? "Create" : "Update"} {type === "CustomerCP" ? "Customer" : type}</h3>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="dashboard__profileSettingsBox">
              <ValidatorForm className="customForm customForm_2" onSubmit={onSubmit}>
                <div className="row">
                  {fields?.map((field) => (
                    <div key={field.name} className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                      <div className="form-group withIcon">
                        <label>
                          {(field.type === "dropdown" && formType == "create") ? "" : field.label}
                          {field.required && <span style={{ color: "red" }}>*</span>}
                        </label>
                        {field.type === "toggle" ? (
                          <div className="form-check form-switch mt-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={field.name}
                              name={field.name}
                              checked={state[field.name] === "active"}
                              onChange={(e) =>
                                setState({ ...state, [field.name]: e.target.checked ? "active" : "inactive" })
                              }
                            />
                            <label className="form-check-label" htmlFor={field.name}>
                              {state[field.name] === "active" ? "Active" : "Inactive"}
                            </label>
                          </div>
                        ) : field.name === "cpcustomerstatus" ? formType == "edit" && <SelectValidator validators={["required"]} errorMessages={["Field can't be empty"]} placeholder="---select---" className="custom-ReactSelect bordered" name="cpcustomerstatus" value={getDropdownObject(state[field.name], option)} options={option} onChange={(e) => handleChangeState("cpcustomerstatus", e.value)} /> : (
                          (field.type === "Enumeration" || field.name === "state") ? <SelectValidator placeholder="---Select---" className="custom-ReactSelect bordered" name={field.name} value={getDropdownObject(state[field.name], field?.option)} options={field?.option} onChange={(e) => handleChangeState(field.name, e.value)} /> :
                            <TextValidator
                              type={field.type || "text"}
                              maxLength={field.maxLength}
                              className="form-control"
                              name={field.name}
                              disabled={field.disabled}
                              value={state[field.name] || ""}
                              placeholder={field.placeholder}
                              min={field?.min}
                              max={field?.max}
                              validators={[
                                ...(field.required ? ["required"] : []),
                                ...(field.name === "mobile" ? ["is10Digits"] : []),
                                ...(field.name === "email" ? ["isValidEmail"] : []),
                              ]}
                              errorMessages={[
                                ...(field.required ? [`Please enter ${field.label?.toLowerCase()}`] : []),
                                ...(field.name === "mobile" ? ["Please enter a valid number"] : []),
                                ...(field.name === "email" ? ["Please enter a valid email"] : []),
                              ]}
                              onChange={onChange}
                            />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="button-section">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateUser;